import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, TemplateRef } from '@angular/core';
import { BrIconComponent } from '../icon/icon.component';

/** Shared summary and lazy detail surface; collections retain data and selection ownership. */
@Component({
  selector: 'article[appDataListCard]',
  standalone: true,
  exportAs: 'appDataListCard',
  imports: [CommonModule, BrIconComponent],
  template: `
    <div class="dl-summary">
      <ng-content select="[data-list-selection]"></ng-content>
      <div class="dl-content"><ng-content></ng-content></div>
      <button *ngIf="detailTemplate" type="button" class="br-btn br-btn--ghost br-icon-btn br-interactive"
              [class.br-interactive--selected]="expanded"
              [attr.aria-label]="expanded ? 'Collapse details' : 'Expand details'"
              [attr.aria-expanded]="expanded" [attr.aria-controls]="detailId"
              (click)="toggle()">
        <br-icon>{{ expanded ? 'expand_less' : 'expand_more' }}</br-icon>
      </button>
    </div>
    <ng-content select="[data-list-footer]"></ng-content>
    <div *ngIf="detailTemplate && expanded" class="br-card dl-detail" role="region"
         aria-label="Record details" [id]="detailId">
      <ng-container [ngTemplateOutlet]="detailTemplate" [ngTemplateOutletContext]="detailContext"></ng-container>
    </div>
  `,
  host: { class: 'br-card dl-item', role: 'listitem' },
  styles: [
    ':host { display: block; padding: var(--br-list-card-padding, var(--br-space-3)); }',
    ':host(.dl-item--selected) { background: var(--br-table-selected-bg); }',
    ':host(.dl-item--revealed) { box-shadow: 0 0 0 2px var(--br-color-primary); }',
    '.dl-summary { display: flex; align-items: start; gap: var(--br-space-2); }',
    '.dl-content { flex: 1; min-width: 0; overflow-wrap: anywhere; }',
    '.dl-detail { margin-top: var(--br-space-3); padding: var(--br-space-3); border-color: var(--br-color-border); }',
  ],
})
export class DataListCardComponent {
  @Input() detailTemplate: TemplateRef<{ $implicit: unknown }> | null = null;
  @Input() detailContext: { $implicit: unknown } = { $implicit: null };
  @Input() expanded = false;
  @Output() expandedChange = new EventEmitter<boolean>();

  private static nextId = 0;
  readonly detailId = `data-list-detail-${++DataListCardComponent.nextId}`;

  toggle(): void {
    this.expanded = !this.expanded;
    this.expandedChange.emit(this.expanded);
  }
}
